import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BasicModal from 'components/Modal'
import { Box, Button, Card, IconButton, Paper, Switch, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import SoftBox from 'components/SoftBox';
import moment from 'moment';
import SoftButton from 'components/SoftButton';
import toast from 'react-hot-toast';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';
import { render } from '@testing-library/react';
import { useAuth } from 'AuthContext';


const User = () => {
  const navigate = useNavigate()
  const [ isApiLoading , setIsApiLoading ] = React.useState(true)
  const [data, setData] = React.useState([]);
  const [isdone, setDone] = React.useState(false);

  const [comment, setComment] = React.useState("");

  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [show, unShow] = React.useState(false);
  const [userDetail, setUserDetail] = React.useState({});
    const [statusSelect, setStatusSelect] = React.useState(null);
      const [sortValue, setSortValue] = React.useState({sortKey:'name',sortDirection:'asc'});
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const columns = [
    {
      id: 'user', isSorting: true,sortDirection:'asc',label: 'User', render: (row) => (
        <SoftBox>
          <span>
            {row?.userId ? row?.userId?.firstName + " " + row?.userId?.lastName : 'N/A'}
          </span>
        </SoftBox>
      )
    },
    { id: 'email', isSorting: true,sortDirection:'asc',sortDirection:'asc',label: 'Email' },
    { id: 'mobileNumber',isSorting: true,sortDirection:'asc',sortDirection:'asc', label: 'Mobile Number' },
   
    { id: "business_name", isSorting: true, sortDirection: 'asc', label: "Merchant",render:(row)=>(
      <>
    {row?.merchantId ? row?.merchantId?.businessName : '-'}
      </>
    ) },
    {
      id: 'createdAt', isSorting: true,sortDirection:'asc',sortDirection:'asc',label: 'Created Date', render: (row) => (

        <SoftBox>
          <span>
            {row?.createdAt ? moment(row?.createdAt).format('MM-DD-YYYY') : ''}
          </span>
        </SoftBox>
      )
    },
    {
      id: 'status',
      label: 'Status',isSorting: true,sortDirection:'asc',
      render: (row) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Switch color="primary" checked={row.status === 'RESOLVED'} onChange={(i, b) => {
            setComment('')
            
            if (row?.comment?.length === 0) {
              setStatusSelect(b);
              setUserDetail(row);
              unShow(true);
            } else {
              handleChangeStatus(row._id, b);
            }
          }} />
          <span>{row.status === 'RESOLVED' ? 'RESOLVED' : 'PENDING'}</span>
        </Box>
      )
    },
    {
      id: 'details',
      label: 'Details',
      render: (row) => (
        <ActionMenu
          items={[
            { label: 'Detail', onClick: () => navigate(`/admin/issue-detail/${row._id}`) },
            { label: 'Add Comment', onClick: () => { setComment(''); setUserDetail(row); unShow(true) } },

          ]}
        />
      )
    }
  ];


  const getUserDetail = async () => {
    setIsApiLoading(true)
    try {
      setDone(false);
      const response = await service.complaint.view({ type: 'REPORT', searchData: search, page, limit: rowsPerPage,sortKey:sortValue.sortKey ,sortDirection:sortValue.sortDirection });
      if (response?.data?.data) {
        setDone(true);

        setData(response.data);
      }
    } catch (error) {
      setDone(true);
      console.error("Failed to fetch business users", error);
    }
      setIsApiLoading(false)
  };

  React.useEffect(() => {
    getUserDetail();
  }, [search, page, rowsPerPage,sortValue]);
  const handleChangeStatus = async (id, type) => {
    try {
      let response = await service.issueReport.updateById(id, { status: type ? 'RESOLVED' : 'OPEN' })
      if (response.status === 201 || response.status === 200) {
        toast.success(response?.data?.message)
        getUserDetail()
      } else {
        setStatusSelect(null)
        toast.error(response?.data?.message)

      }
    } catch (error) {
      setStatusSelect(null)
      toast.error(error?.response?.data?.message)
    }
  }

  const handleSubmit = async () => {
    try {
      const payload = {
        // email: userDetail.email,
        // type: 'REPORT',
        // mobile: userDetail.mobileNumber,
        comment: comment,
      };

      const response = await service.issueReport.comment(userDetail._id, payload);

      if ([200, 201].includes(response.status)) {
        toast.success(response?.data?.message || "Comment submitted successfully");
         if(statusSelect){
          handleChangeStatus(userDetail._id, statusSelect);
        }
        setStatusSelect(null)
        setComment("");
        setUserDetail({});
        unShow();
        getUserDetail?.();
      } else {
        setStatusSelect(null)
        toast.error(response?.data?.message || "Failed to submit comment");
      }
    } catch (error) {
      setStatusSelect(null)
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };



  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
          <CustomTable
            title="All Issues Report" columns={columns} rows={data?.data} 
            search={search}
            setSearch={setSearch}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            isApiLoading={isApiLoading}
            totalPages={data?.pagination?.totalItems}
            onRequestSort={(id, direction) => {
            setSortValue({sortKey:id,sortDirection:direction})
          }}
          />
        </Paper>

      </DashboardLayout>
      <SoftBox>
        <BasicModal
          show={show}
          unShow={unShow}
          title="Resolution Comment"
          width={800}
          height={400}
        >
          <SoftBox sx={{ width: "100%" }}>
            {/* <SoftTypography
              component="label"
              variant="button"
              fontWeight="medium"
              gutterBottom
            >
              Resolution Comment
            </SoftTypography> */}
            <SoftInput
              multiline
              rows={10}
              placeholder="Type your resolution comment here..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              fullWidth
            />
          </SoftBox>

          <SoftBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
            {/* <SoftButton variant="outlined" color="error" onClick={unShow}>
                  Cancel
                </SoftButton> */}
            <SoftButton color="info" variant="gradient" onClick={handleSubmit} disabled={!comment}>
              Submit
            </SoftButton>
          </SoftBox>
        </BasicModal>
      </SoftBox>
    </>
  );
}

export default User
